import './scss/index.scss';
import { dcFactory } from 'dc';
import AHSearchComponent from "./js/search.component";

dcFactory.register(AHSearchComponent);
